// Finals Focus 2026: Mon 2026-12-07 00:00 through the end of Sun 2027-01-24, New York time (EST all
// the way, so UTC-5), written as UTC instants so every browser agrees whatever its own time zone.
// Same shape as a shared/seasons.js entry, so it can join that list once Spooky Week's seasons
// code is on this branch.
export const FINALS = { id: "finals-2026", label: "Finals Focus", from: Date.parse("2026-12-07T05:00:00Z"), until: Date.parse("2027-01-25T05:00:00Z") };

export const finalsOpen = (now = Date.now()) => now >= FINALS.from && now < FINALS.until;
